const useLocale = () => {
  const dir = localStorage.getItem("dir");
  if (!dir) {
    localStorage.setItem("dir", "rtl");
  }
  return { dir: dir ?? "rtl" };
};

export default useLocale;
